import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { ThemeToggle } from '@/components/common/ThemeToggle';
import { Wordmark } from '@/components/common/Wordmark';

export function ShopShell() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="sticky top-0 z-30 border-b border-border/60 bg-card/80 backdrop-blur-xl">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between gap-2 px-4 sm:px-6">
          <Link
            to="/"
            className="transition-opacity duration-300 hover:opacity-80"
            title={t('common.appName')}
          >
            <Wordmark size="sm" />
          </Link>
          <div className="flex items-center gap-2">
            <LanguageSwitcher />
            <ThemeToggle />
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-border/60 bg-faint">
        <div className="mx-auto flex max-w-5xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm sm:flex-row sm:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-muted transition-colors hover:text-ink"
          >
            <span>{t('shop.poweredBy')}</span>
            <Wordmark size="sm" />
          </Link>
          <Link
            to="/signup"
            className="link-underline inline-flex items-center gap-1 font-medium text-primary"
          >
            {t('shop.createYours')}
            <ArrowUpRight size={14} />
          </Link>
        </div>
      </footer>
    </div>
  );
}
